import React from 'react'
import { Translation } from '@morningtrain/react-translations'
import { ForEachModel, SubmitFormOnPipe, ValueToCollection, WhenModelValue } from '@morningtrain/react-resources'
import * as Fields from 'support/fields'
import * as Displays from 'support/displays'
import { Fieldset } from 'layouts'
import SalaryStepsFields from '../partials/SalaryStepsFields'
import UpdateModelOnChange from 'support/utilities/UpdateModelOnChange'
import * as UI from 'ui'
import EmploymentTypeField from 'pages/app/hr/employments/partials/EmploymentTypeField'
import classNames from 'classnames'
import { OnClickPipeline, WhenIsPiping } from '@morningtrain/react-pipelines'
import { LoadingSpinner } from 'ui/animations'

export default function EditEmploymentForm () {

  const stepOneRef = React.useRef(null)
  const stepOneBreadcrumbRef = React.useRef(null)
  const stepOneButtonRef = React.useRef(null)

  const stepTwoRef = React.useRef(null)
  const stepTwoBreadcrumbRef = React.useRef(null)
  const stepTwoButtonRef = React.useRef(null)

  const updateStep = (newStep) => {
    stepOneRef.current.classList.toggle('hidden', newStep === 2)
    stepOneBreadcrumbRef.current.classList.toggle('text-gray-400', newStep === 2)
    stepOneButtonRef.current.classList.toggle('hidden', newStep === 2)

    stepTwoRef.current.classList.toggle('hidden', newStep === 1)
    stepTwoBreadcrumbRef.current.classList.toggle('text-gray-400', newStep === 1)
    stepTwoButtonRef.current.classList.toggle('hidden', newStep === 1)
  }

  return (
          <>
            <UI.Breadcrumbs className="mb-4">
              <div
                      ref={stepOneBreadcrumbRef}
                      className={classNames('breadcrumb text-sm cursor-pointer hover:text-primary-500')}
                      onClick={() => updateStep(1)}>
                <Translation name="titles.employment_information"/>
              </div>
              <div
                      ref={stepTwoBreadcrumbRef}
                      className={classNames('breadcrumb text-sm cursor-pointer hover:text-primary-500')}
                      onClick={() => updateStep(2)}>
                <Translation name="titles.salary_steps"/>
              </div>
            </UI.Breadcrumbs>
            <div ref={stepOneRef}>
              <Fieldset>

                <Fieldset cols={2} label={<Translation name="titles.personal_information"/>}>
                  <Fields.Hidden name="user.id"/>

                  <Fields.Input
                          name="user.first_name"
                          label={<Translation name="fields.first_name.label"/>}
                  />
                  <Fields.Input
                          name="user.last_name"
                          label={<Translation name="fields.last_name.label"/>}
                  />
                  <Fields.Input
                          name="user.email"
                          label={<Translation name="fields.email.label"/>}
                  />
                  <Fields.TabsField
                          name="user.locale"
                          enum="language"
                          defaultValue="da"
                          label={<Translation name="fields.locale.label"/>}
                          fullWidth
                  />

                </Fieldset>

                <Fieldset label={<Translation name="titles.employment_information"/>}>
                  <Fieldset cols={2}>

                    <Fields.DepartmentsField
                            label={<Translation name="fields.base_department.label"/>}
                            withSelectAll={false}
                    />

                    <EmploymentTypeField/>

                    <WhenModelValue name="id">
                      <Fields.Date
                              name="start_at"
                              label={<Translation name="fields.start_at.label_edit"/>}
                      />
                    </WhenModelValue>
                    <WhenModelValue name="id" negate>
                      <Fields.Date
                              name="start_at"
                              label={<Translation name="fields.start_at.label"/>}
                      />
                    </WhenModelValue>

                    <Fields.Number
                            name="weekly_hours"
                            min={0}
                            step={0.1}
                            defaultValue={8}
                            label={<Translation name="fields.weekly_hours.label"/>}
                    />

                  </Fieldset>

                  <Fieldset>
                    <Fields.DepartmentsField
                            name="user.department_ids"
                            label={<Translation name="fields.additional_departments.label"/>}
                            multiple
                    />
                  </Fieldset>

                  <Fieldset cols={2}>
                    <Fieldset>
                      <UpdateModelOnChange name="is_danish_citizen">
                        <Fields.Checkbox
                                name="is_danish_citizen"
                                className="checkbox-form-element"
                                defaultValue={1}
                                label={<Translation name="fields.is_danish_citizen.label"/>}
                        />
                      </UpdateModelOnChange>
                      <WhenModelValue name="is_danish_citizen" condition={false}>
                        <Fields.Date
                                name="permit_expires_at"
                                label={<Translation name="fields.permit_expires_at.label"/>}
                        />
                        <Fields.File
                                name="user.work_permit_files[]"
                                multiple
                                label={<Translation name="fields.work_permit.label"/>}
                        >
                          <UI.VerticalList className="mt-4 w-2/3">
                            <ValueToCollection name="user.work_permit_files">
                              <ForEachModel>
                                <Displays.Link name="url">
                                  <UI.Text truncate block className="w-full">
                                    <Displays.Text name="name"/>
                                  </UI.Text>
                                </Displays.Link>
                              </ForEachModel>
                            </ValueToCollection>
                          </UI.VerticalList>
                        </Fields.File>
                      </WhenModelValue>
                    </Fieldset>
                    <Fieldset>
                      <UpdateModelOnChange name="time_limit_period">
                        <Fields.Select
                                name="time_limit_period"
                                enum="time_limit_period"
                                label={<Translation name="fields.time_limit_period.label"/>}
                        />
                      </UpdateModelOnChange>
                      <WhenModelValue name="time_limit_period" condition="weekly">
                        <Fields.Number
                                name="time_limit_amount"
                                label={<Translation name="fields.time_limit_amount.label"/>}
                        />
                      </WhenModelValue>
                    </Fieldset>
                  </Fieldset>

                </Fieldset>
              </Fieldset>
            </div>
            <div ref={stepTwoRef} className="hidden">
              <SalaryStepsFields cols={2}/>
            </div>
            <UI.ButtonWrap grow>
              <div ref={stepOneButtonRef}>
                <UI.Button onClick={() => updateStep(2)}>
                  <UI.WithIcon icon={<UI.Icons.ArrowRight/>} size={4} placement="right">
                    <Translation name={'hr.employments.actions.fill_salary_steps'}/>
                  </UI.WithIcon>
                </UI.Button>
              </div>
              <div ref={stepTwoButtonRef} className="hidden">
                <OnClickPipeline trigger={(
                        <UI.Button>
                          <UI.Text className="flex space-x-3 items-center" block>
                            <div>
                              <Translation name={'generic.save'}/>
                            </div>
                            <WhenIsPiping>
                              <LoadingSpinner color="white"/>
                            </WhenIsPiping>
                          </UI.Text>
                        </UI.Button>
                )}>
                  <SubmitFormOnPipe/>
                </OnClickPipeline>
              </div>
            </UI.ButtonWrap>
          </>
  )
}
